import { ApplicationConfig } from '@angular/core';

import { routes } from './app.routes';
import { sharedAppConfig } from '../../../shared/src/lib/shared-app.config';
import { environment } from '../../../shared/src/environments/environment';
import { ESystem } from '../../../shared/src/lib/models/index.model';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LicenseScopeInterceptor } from 'projects/admin/src/app/license-scope/license-scope.interceptor';
// import { authReducer } from './@ngrx/reducers/auth.reducer';

function setVariables() {
  environment.appName = 'Admin Portal';
  // environment.allowRegistration = false;
  environment.system = ESystem.admin;
  environment.sentryKey =
    'https://92c694630cb97e9aa95d2fd63bf4e3da@o4507594374250496.ingest.de.sentry.io/4507596104597584';
  return environment;
}
const sharedConfig = sharedAppConfig(routes, setVariables());

export const appConfig: ApplicationConfig = {
  ...sharedConfig,
  providers: [
    ...sharedConfig.providers,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LicenseScopeInterceptor,
      multi: true,
    },
  ],
};
